import { getRoomName } from '../base/conference/functions';
import {
  DOMINANT_SPEAKER_CHANGED,
  PARTICIPANT_LEFT,
  PARTICIPANT_UPDATED,
  PIN_PARTICIPANT,
  getDominantSpeakerParticipant
} from '../base/participants';
import { MiddlewareRegistry } from '../base/redux';
import { isTestModeEnabled } from '../base/testing/functions';
import { TRACK_ADDED, TRACK_REMOVED } from '../base/tracks/actionTypes';
import { TOGGLE_DOCUMENT_EDITING } from '../etherpad/actionTypes';
import { sendPairACK } from '../login/actions';
import { SET_SETTINGS } from '../settings/actionTypes';
import { SELECT_ROTATION_PARTICIPANT } from './actionTypes';

import {
  checkParticipantInLargeVideo,
  selectParticipantInLargeVideo
} from './actions';
import logger from './logger';

import './subscriber';

/**
 * Middleware that catches actions related to participants and tracks and
 * dispatches an action to select a participant depicted by LargeVideo.
 *
 * @param {Store} store - Redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register((store) => (next) => (action) => {
  switch (action.type) {
    case DOMINANT_SPEAKER_CHANGED: {
      const state = store.getState();
      // const localParticipant = getLocalParticipant(state);
      const dominantSpeaker = getDominantSpeakerParticipant(state);

      if (dominantSpeaker?.id === action.participant.id) {
        return next(action);
      }

      const result = next(action);

      if (isTestModeEnabled(state)) {
        logger.info(
          `Dominant speaker changed event for: ${action.participant.id}`
        );
      }

      // TODO removed large video selection on dominant speaker changes
      // if (localParticipant && localParticipant.id !== action.participant.id) {
      //   store.dispatch(selectParticipantInLargeVideo());
      // }

      return result;
    }
    case PARTICIPANT_LEFT: {
      const result = next(action);

      store.dispatch(checkParticipantInLargeVideo(action.participant.id, true));

      return result;
    }
    case PARTICIPANT_UPDATED: {
      const result = next(action);

      store.dispatch(
        checkParticipantInLargeVideo(action.participant.id, false)
      );

      return result;
    }
    case SET_SETTINGS:
    case PIN_PARTICIPANT:
    case SELECT_ROTATION_PARTICIPANT: {
      if (action.participantId) {
        store.dispatch(sendPairACK(getRoomName(store.getState())));
      }
    }
    // eslint-disable-next-line no-fallthrough
    case TOGGLE_DOCUMENT_EDITING:
    case TRACK_ADDED:
    case TRACK_REMOVED: {
      const result = next(action);

      store.dispatch(selectParticipantInLargeVideo());

      return result;
    }
  }
  const result = next(action);

  return result;
});
